<template>
  <v-dialog v-model="dialogVisible" max-width="500px">
    <v-card>
      <v-card-title><span class="text-h6">{{ formTitle }}</span></v-card-title>
      <v-card-text class="overflow-card" style="height: 350px;overflow-y: auto;">
        <v-container>
          <v-row>
            <v-col cols="12" sm="12" md="12">
              <v-select dense outlined
                v-model="editedItem.group_analysis_id"
                :items="analysisGroupOptions"
                item-value="SEQ_ID"
                item-text="GROUP_ANALYSIS"
                label="Topic Name"
              ></v-select>
            </v-col>
            <v-col cols="12" sm="12" md="12">
              <v-select label="Status" dense outlined
              :items="status_topic_insert"
              item-text="name_topic"
              item-value="value_topic"
              v-model="editedItem.topicstatus"
              ></v-select>
            </v-col>

          </v-row>
        </v-container>
      </v-card-text>

      <v-divider></v-divider>
      <v-card-actions class="py-3">
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" style="width: 90px;" rounded outlined dense @click="close">
          Cancel
        </v-btn>
        <v-btn color="blue darken-1" style="width: 90px;" rounded dark dense @click="$emit('save')">
          Save
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    value: Boolean,
    editedItem: { type: Object, default: () => ({}) },
    topicstatus_topic: { type: Number, default: 1 },
    item_insert_dinamis: { type: Array, default: () => [{ keywordname: '' }] },
    status_topic_insert: { type: Array, default: () => [] },
    formTitle: { type: String, default: '' },
    topicOptions: { type: Array, default: () => [] },
    analysisGroupOptions: { type: Array, default: () => [] }
  },
  computed: {
    dialogVisible: {
      get() { return this.value },
      set(val) { this.$emit('input', val) }
    }
  },
  methods: {
    close() {
      this.dialogVisible = false
    }
  }
}
</script>
